<app-left-menu [showMenu]="false"></app-left-menu>
<div id="main-container">

    <app-header [title]="title" [showHistoryButton]="true" [showAddSiteButton]=true></app-header>
    <div class="pharse" style="margin-top: 80px; text-align: center;padding-bottom: 10px;font-style:italic">
        {{'ProviderSite.Pharse'|translate}}</div>

    <div  style="margin-top: 10px;">

        <ul class="nav nav-tabs content" role="tablist">
            <li role="presentation" class="active"><a href="#activesites" role="tab" data-toggle="tab"
                    aria-expanded="true">{{'Common.Active' | translate}}
                </a>
            </li>
            <li role="presentation"><a href="#inactivesites" role="tab" data-toggle="tab"
                    aria-expanded="false">{{'Common.InActive' | translate}}</a>
            </li>

        </ul>
    </div>
    <div class="page-content ">

        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="activesites">
                <table *ngIf="activeSites?.length>0" class="table table-bordered" id="table">
                    <thead>
                        <tr>
                            <th> {{'ProviderSite.Table.Header.Address1' | translate}}

                            </th>
                            <th> {{'ProviderSite.Table.Header.ContactNumber' | translate}}</th>
                            <th> {{'ProviderSite.Table.Header.Description'| translate}}</th>
                            <th style="text-align: center;"> {{'Common.Action'| translate}}</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr [class.alternate]="i%2!=0" *ngFor="let item of activeSites; index as i;">
                            <td style="width: 200px;">

                                <span style="display: block;"> {{item.Address1 }} </span>
                                <span style="display: block;"> {{item.Address2 }} </span>

                                <span style="display: block;"> {{item.City}}, {{item.State}} - {{item.Zipcode}} </span>
                                <span style="display: block;"> </span>


                            </td>
                            <td style="width: 140px;">{{item.ContactNumber | mask: '000-000-0000' }}</td>

                            <td>{{item.Description}}</td>

                            <td style="width: 50px;text-align: center;">
                                <a [routerLink]="['edit',item.Id]" class="icon edit round"
                                    routerLinkActive="router-link-active" href="javascript:void(0)"></a>
                            </td>

                        </tr>
                    </tbody>
                </table>
                <div class="not-found" *ngIf="activeSites?.length==''">{{'ProviderSite.NoRecord.Active'|translate}}
                </div>
            </div>
            <div role="tabpanel" class="tab-pane " id="inactivesites">
                <table *ngIf="inActiveSites?.length>0" class="table table-bordered" id="table">
                    <thead>
                        <tr>
                            <th> {{'ProviderSite.Table.Header.Address1' | translate}}

                            </th>
                            <th> {{'ProviderSite.Table.Header.ContactNumber' | translate}}</th>
                            <th> {{'ProviderSite.Table.Header.Description'| translate}}</th>
                            <th style="text-align: center;"> {{'Common.Action'| translate}}</th>


                        </tr>
                    </thead>
                    <tbody>

                        <tr [class.alternate]="i%2!=0" *ngFor="let item of inActiveSites; index as i;">

                            <td style="width: 200px;">

                                <span style="display: block;"> {{item.Address1 }} </span>
                                <span style="display: block;"> {{item.Address2 }} </span>

                                <span style="display: block;"> {{item.City}}, {{item.State}} - {{item.Zipcode}} </span>
                                <span style="display: block;"> </span>



                            </td>
                            <td style="width: 140px;">{{item.ContactNumber | mask: '000-000-0000' }}</td>

                            <td>{{item.Description}}</td>

                            <td style="width: 50px;text-align: center;">
                                <a [routerLink]="['edit',item.Id]" class="icon edit round"
                                    routerLinkActive="router-link-active" href="javascript:void(0)"></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="not-found" *ngIf="inActiveSites?.length==''">
                    {{'ProviderSite.NoRecord.InActive'|translate}}
                </div>
            </div>
        </div>
    </div>
</div>